<template>
  <div>
    <DxPopup
      :visible="visible"
      :hide-on-outside-click="false"
      :drag-enabled="false"
      :title="'Add New Customer / Contact'"
      :width="'75%'"
      :height="610"
      :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-customer-and-contact' }"
      :onHiding="onHiding"
      :onShown="onShown"
      :onShowing="onShowing"
    >
      <div class="css-v2 gc-popup-form">
        <DxToolbar class="view-toolbar">
          <DxItem
            widget="dxForm"
            location="before"
            :options="{
              formData: dataModel,
              items: toolbarFormItems,
              validationGroup: 'toolbarForm',
              labelLocation: 'left',
              onContentReady: onToolbarFormContentReady,
            }"
            locate-in-menu="auto"
          ></DxItem>
        </DxToolbar>

        <div class="customer-form">
          <gc-form
            :formOptions="{
              gcLabelLocation: 'left',
            }"
            :formItems="getFormItems"
            :formHeight="435"
            :isNormal="true"
            :data-model="dataModel"
            :formMode="'create'"
            :validationGroup="'gc-popup-customer-and-contact'"
            :formTitle="'gc-popup'"
            :ref="'add-item-popup-form'"
          ></gc-form>
        </div>
      </div>

      <div class="footer modal-popup-footer-action-container">
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="onHiding"
        />
        <DxButton
          text="Create"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="onSaveCustomerContact()"
          :ref="'footer-save-btn'"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import { CustomerService } from "../_services/api/customers/customer.service";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    callback: {
      type: Function,
      default: function () {},
    },
    displayValidationSummary: {
      type: Function,
      default: function () {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    selectedCustomerData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataModel: {
        Code: undefined,
        CustomerName: undefined,
        MailStreet1: undefined,
        MailStreet2: undefined,
        MailSuburb: undefined,
        MailState: undefined,
        MailPostCode: undefined,
        MailCountry: undefined,
        Status: "P",

        FirstName: undefined,
        Surname: undefined,
        Position: undefined,
        Email: undefined,
        Phone: undefined,
        Mobile: undefined,
        ContactMailStreet1: undefined,
        ContactMailStreet2: undefined,
        ContactMailSuburb: undefined,
        ContactMailState: undefined,
        ContactMailPostCode: undefined,
        ContactMailCountry: undefined,
      },
    };
  },
  async mounted() {},
  methods: {
    async onSaveCustomerContact() {
      let toolbarForm = await validationEngine.validateGroup("toolbarForm");
      let headerform = await validationEngine.validateGroup(
        "gc-popup-customer-and-contact"
      );

      if (!toolbarForm.isValid || !headerform.isValid)
        this.displayValidationSummary(
          toolbarForm.brokenRules.concat(headerform.brokenRules)
        );
      else {
        this.setLoading(true);
        await CustomerService.saveCustomerWithContact({
          CustomerCode: this.dataModel.Code,
          CustomerName: this.dataModel.CustomerName,
          Phone: this.dataModel.Phone,
          Inactive: "N",
          Status: this.dataModel.Status,
          Country: this.dataModel.MailCountry,
          Postcode: this.dataModel.MailPostCode,
          State: this.dataModel.State,
          StreetLine1: this.dataModel.MailStreet1,
          StreetLine2: this.dataModel.MailStreet2,
          Suburb: this.dataModel.MailSuburb,
          CustomerContact: {
            FirstName: this.dataModel.FirstName,
            Surname: this.dataModel.Surname,
            Position: this.dataModel.Position,
            Email: this.dataModel.Email,
            Phone: this.dataModel.Phone,
            Mobile: this.dataModel.Mobile,
            StreetLine1: this.dataModel.ContactMailStreet1,
            StreetLine2: this.dataModel.ContactMailStreet2,
            Suburb: this.dataModel.ContactMailSuburb,
            Inactive: "N",
            Country: this.dataModel.ContactMailCountry,
            Postcode: this.dataModel.ContactMailPostCode,
            State: this.dataModel.ContactMailState,
          },
        })
          .then((res) => {
            this.setLoading(false);
            this.callback(res);
            this.resetDataModel();
          })
          .catch((err) => {
            this.setLoading(false);
            this.displayServerError(err);
          });
      }
    },
    onHiding() {
      this.resetDataModel();
      this.callback(false);
    },

    onToolbarFormContentReady(e) {
      e.component.instance().getEditor("CustomerName").focus();
      this.ToolbarFormComponent = e.component;
      validationEngine.validateGroup("toolbarForm");
    },
    onShowing() {
      this.setLoading(true);
      if (this.selectedCustomerData) {
        this.dataModel.Code = this.selectedCustomerData.Code;
        this.dataModel.CustomerName = this.selectedCustomerData.Name;
        this.dataModel.MailStreet1 =
          this.selectedCustomerData.MailAddressStreetLine1;
        this.dataModel.MailStreet2 =
          this.selectedCustomerData.MailAddressStreetLine2;
        this.dataModel.MailSuburb = this.selectedCustomerData.MailAddressSuburb;
        this.dataModel.MailState = this.selectedCustomerData.MailAddressState;
        this.dataModel.MailPostCode =
          this.selectedCustomerData.MailAddressPostcode;
        this.dataModel.MailCountry =
          this.selectedCustomerData.MailAddressCountry;
        this.dataModel.Status = this.selectedCustomerData.Status;
      } else {
        this.dataModel.Status = "P";
      }
    },
    onShown() {
      this.setLoading(false);
    },
    resetDataModel() {
      if (this.ToolbarFormComponent) this.ToolbarFormComponent.resetValues();
      let mainForm = this.$refs["add-item-popup-form"].$refs["gc-form-comp"];
      if (mainForm) {
        let formInstance = mainForm.instance;
        if (formInstance) formInstance.resetValues();
      }

      this.dataModel.State = "P";
    },
  },
  computed: {
    toolbarFormItems() {
      return [
        {
          dataField: "CustomerName",
          label: { text: "Name", visible: false },
          editorOptions: {
            width: 350,
            maxLength: 100,
            placeholder: "Customer Name",
            disabled: this.dataModel.Code,
          },
          validationRules: [
            {
              type: "required",
              message: "Name is required",
            },
          ],
        },
      ];
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "Customer Information",
              cssClass: "header-form-items",
              colCount: 1,
              items: [
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "MailStreet1",
                  editorOptions: {
                    maxLength: 50,
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "MailStreet2",
                  editorOptions: {
                    maxLength: 50,
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
                {
                  screenField: "Suburb",
                  dataField: "MailSuburb",
                  editorOptions: {
                    maxLength: 50,
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
                {
                  screenField: "MailAddressState",
                  dataField: "MailState",
                  editorOptions: {
                    maxLength: 100,
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
                {
                  screenField: "PostCode",
                  dataField: "MailPostCode",
                  editorOptions: {
                    maxLength: 20,
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
                {
                  screenField: "MailAddressCountry",
                  dataField: "MailCountry",
                  editorOptions: {
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
                {
                  dataField: "Status",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  gcLabel: "Status",
                  editorOptions: {
                    editorType: "dxSelectBox",
                    items: [
                      {
                        text: "Approved",
                        value: "A",
                      },
                      {
                        text: "Enquiry",
                        value: "E",
                      },
                      {
                        text: "Pending",
                        value: "P",
                      },
                    ],
                    valueExpr: "value",
                    displayExpr: "text",
                    allowUpdate: this.dataModel.Code == undefined,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "Contact Information",
              cssClass: "header-form-items",
              colCount: 1,
              items: [
                {
                  screenField: "FirstName",
                  required: true,
                  editorOptions: {
                    maxLength: 50,
                  },
                },
                {
                  screenField: "Surname",
                  required: true,
                  editorOptions: {
                    maxLength: 50,
                  },
                },
                {
                  dataField: "Position",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  screenField: "Email",
                  required: true,
                  editorOptions: {
                    maxLength: 200,
                  },
                },
                {
                  screenField: "Phone",
                  editorOptions: {
                    maxLength: 20,
                  },
                },
                {
                  dataField: "Mobile",
                  editorOptions: {
                    maxLength: 20,
                  },
                },
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "ContactMailStreet1",
                  editorOptions: {
                    maxLength: 50,
                  },
                  required: true,
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "ContactMailStreet2",
                  editorOptions: {
                    maxLength: 50,
                  },
                },
                {
                  screenField: "Suburb",
                  dataField: "ContactMailSuburb",
                  editorOptions: {
                    maxLength: 50,
                  },
                  required: true,
                },
                {
                  screenField: "MailAddressState",
                  dataField: "ContactMailState",
                  editorOptions: {
                    maxLength: 100,
                  },
                  required: true,
                },
                {
                  screenField: "PostCode",
                  dataField: "ContactMailPostCode",
                  editorOptions: {
                    maxLength: 20,
                  },
                  required: true,
                },
                {
                  screenField: "MailAddressCountry",
                  dataField: "ContactMailCountry",
                  editorOptions: {
                    maxLength: 50,
                  },
                  required: true,
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.gc-popup-customer-and-contact {
  .gc-popup-form {
    .view-toolbar {
      .save-button {
        .dx-widget.dx-button.dx-button-mode-text {
          // border: 1px solid gray;
        }
      }
    }

    .customer-form {
      padding-top: 12px;
    }
  }
}
</style>
